import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@vueuse/head'
import { VueFire, VueFireAuth } from 'vuefire'
import App from '@/App.vue'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import { firebaseApp, auth } from '@/fb'
import { useDataStore } from '@/stores/data'
import { debug } from '@/logger'
import { markAuthReady } from '@/authState'
import { registerSW } from 'virtual:pwa-register'
import '@/assets/global.css'

// Mount immediately so the public shell can paint while Firebase resolves auth.
const pinia = createPinia()

createApp(App)
  .use(pinia)
  .use(router)
  .use(vuetify)
  .use(createHead())
  .use(VueFire, {
    firebaseApp,
    modules: [VueFireAuth()]
  })
  .mount("#app")

const store = useDataStore()
let hasReceivedInitialAuthState = false

auth.onAuthStateChanged(async (user) => {
  debug("main: User Auth state changed.")
  await store.onUserChanged(user)
  // The router must not evaluate protected routes until Firebase has restored
  // the persisted session and the stores have received it.
  if (!hasReceivedInitialAuthState) {
    markAuthReady()
  } else if (!user && router.currentRoute.value.matched.some((record) => record.meta.requiresAuth)) {
    await router.replace({
      path: "/login",
      query: { signInSuccessUrl: router.currentRoute.value.fullPath }
    })
  }
  hasReceivedInitialAuthState = true
})

registerSW({
  immediate: true,
  onNeedRefresh() {
    if (confirm('New update found! Would you like to reload?')) {
      window.location.reload()
    }
  },
  onOfflineReady() {
    debug('App ready to work offline')
  }
})
